<template>
    <div class="btns-wrap">
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.btns-wrap {
    width: calc(100% + 10px);
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: -5px;

    button {
        margin: 5px;
    }
}
</style>